$(document).ready(function(){
    var current_fs, next_fs, previous_fs; //fieldsets
    var opacity;
    var current = 1;
    var steps = $("fieldset").length;
    setProgressBar(current);
    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    function validatePhone(phone) {
        const re = /^[\s()+-]*([0-9][\s()+-]*){9,20}$/;
        // return re.test(String(phone).toLowerCase() && phone.startsWith('0'))
         return re.test(String(phone).toLowerCase());
    }
    function validateUrl(string) {
      var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
      return (res !== null)
    };
    function nextStep() {
        $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
        //show the next fieldset
        next_fs.show();
        //hide the current fieldset with style
        current_fs.animate({opacity: 0}, {
        step: function(now) {
        // for making fielset appear animation
        opacity = 1 - now;
        current_fs.css({
          'display': 'none',
          'position': 'relative'
        });
        next_fs.css({'opacity': opacity});
        },
        duration: 500
        });
        setProgressBar(++current);    
    }
    $(".next").click(function(){
        $.scrollTo('#heading');
        current_fs = $(this).parent();
        next_fs = $(this).parent().next();
        if (current == 1) {
            if ($('input[name="title"]').val() && $('#description').val() && $('#description').val().length >= 150) {
                $('input[name="title"]').css('border', '1px solid #ccc');
                $('#description').css('border', '1px solid #ccc');
                nextStep();
            } else {
                if (!$('input[name="title"]').val()){
                    $('input[name="title"]').css('border', '1px solid red');
                    if (!$('input[name="title"]').next('.err').length) {
                        $('input[name="title"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Please enter the name of place!</div>');
                        $('input[name="title"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!$('#description').val()) {
                    $('#description').css('border', '1px solid red');
                    if (!$('.en_minimum_chars').next('.err').length) {
                        $('.en_minimum_chars').after('<div class="err" style="color: red; margin-bottom: 20px;">Please add description!</div>');
                        $('.en_minimum_chars').css('margin-bottom', '0px');
                    }
                }
                if ($('#description').val().length < 150) {
                    $('#description').css('border', '1px solid red');
                    if (!$('.en_minimum_chars').next('.err').length) {
                        $('.en_minimum_chars').after('<div class="err" style="color: red; margin-bottom: 20px;">Minimum of 150 characters!</div>');
                        $('.en_minimum_chars').css('margin-bottom', '0px');
                    }
                }
            }
        } else if (current == 2) {
            if ($('input[name="gmap"]').val() && $('.emirates > .form-checkbox input[type="checkbox"]:checked').length && $('.activities > .form-checkbox input[type="checkbox"]:checked').length && validateUrl($('input[name="gmap"]').val())) {
                $('input[name="gmap"]').css('border', '1px solid #ccc');
                $('.emirates').css('border','1px solid #ccc');
                $('.activities').css('border','1px solid #ccc');
                $('.age_group').css('border','1px solid #ccc');
                nextStep();
            } else {
                if (!$('input[name="gmap"]').val()){
                    $('input[name="gmap"]').css('border', '1px solid red');
                    if (!$('input[name="gmap"]').next('.err').length) {
                        $('input[name="gmap"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Please add google map link!</div>');
                        $('input[name="gmap"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!validateUrl($('input[name="gmap"]').val())){
                    $('input[name="gmap"]').css('border', '1px solid red');
                    if (!$('input[name="gmap"]').next('.err').length) {
                        $('input[name="gmap"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Add a valid link!</div>');
                        $('input[name="gmap"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!$('.emirates > .form-checkbox input[type="checkbox"]:checked').length) {
                    $('.emirates').css('border','1px solid red');
                    if (!$('.emirates').next('.err').length) {
                        $('.emirates').after('<div class="err" style="color: red; margin-bottom: 20px;">Please select emirate!</div>');
                        $('.emirates').css('margin-bottom', '0px');
                    }
                }
                if (!$('.activities > .form-checkbox input[type="checkbox"]:checked').length) {
                    $('.activities').css('border','1px solid red');
                    if (!$('.activities').next('.err').length) {
                        $('.activities').after('<div class="err" style="color: red; margin-bottom: 20px;">Please select atleast one activity!</div>');
                        $('.activities').css('margin-bottom', '0px');
                    }
                }
                if (!$('.age_group > .form-checkbox input[type="checkbox"]:checked').length) {
                    $('.age_group').css('border','1px solid red');
                    if (!$('.age_group').next('.err').length) {
                        $('.age_group').after('<div class="err" style="color: red; margin-bottom: 20px;">Please select age group!</div>');
                        $('.age_group').css('margin-bottom', '0px');
                    }
                }
            }
        } else if (current == 3) {
            if ($('input[name="mobile"]').val() && $('input[name="whatsapp"]').val() && $('input[name="email"]').val()  && validateEmail($('input[name="email"]').val()) && validatePhone($('input[name="mobile"]').val()) && validatePhone($('input[name="whatsapp"]').val())) {
                $('input[name="mobile"]').css('border', '1px solid #ccc');
                $('input[name="whatsapp"]').css('border', '1px solid #ccc');
                $('input[name="email"]').css('border', '1px solid #ccc');
                setTimeout(function() {
                    $('form#msform').submit();
                }, 2000)
                // $('form#msform').submit(function(e) {
                //     e.preventDefault();
                // })
                nextStep();
            } else {
                if (!$('.uppy-Dashboard-Item').length){;
                    $('#drag-drop-area').css('border', '1px solid red');
                    if (!$('#drag-drop-area').next('.err').length) {
                        $('#drag-drop-area').next('.err').remove();
                        $('#drag-drop-area').after('<div class="err" style="color: red; margin-bottom: 20px;">Please add maximum of 10 images!</div>');
                        $('#drag-drop-area').css('margin-bottom', '0px');                        
                    }
                }
                if ($('.uppy-Dashboard-Item').length > 10){;
                    $('#drag-drop-area').css('border', '1px solid red');
                    if (!$('#drag-drop-area').next('.err').length) {
                        $('#drag-drop-area').next('.err').remove();
                        $('#drag-drop-area').after('<div class="err" style="color: red; margin-bottom: 20px;">Please add maximum of 10 images!</div>');
                        $('#drag-drop-area').css('margin-bottom', '0px');                        
                    }
                }
                if (!$('input[name="mobile"]').val()){
                    $('input[name="mobile"]').css('border', '1px solid red');
                    if (!$('input[name="mobile"]').next('.err').length) {
                        $('input[name="mobile"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Please enter mobile number!</div>');
                        $('input[name="mobile"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!validatePhone($('input[name="mobile"]').val())){
                    $('input[name="mobile"]').css('border', '1px solid red');
                    if (!$('input[name="mobile"]').next('.err').length) {
                        $('input[name="mobile"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Phone number not valid!</div>');
                        $('input[name="mobile"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!$('input[name="whatsapp"]').val()){
                    $('input[name="whatsapp"]').css('border', '1px solid red');
                    if (!$('input[name="whatsapp"]').next('.err').length) {
                        $('input[name="whatsapp"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Please enter whatsapp number!</div>');
                        $('input[name="whatsapp"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!validatePhone($('input[name="whatsapp"]').val())){
                    $('input[name="whatsapp"]').css('border', '1px solid red');
                    if (!$('input[name="whatsapp"]').next('.err').length) {
                        $('input[name="whatsapp"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Whatsapp number not valid!</div>');
                        $('input[name="whatsapp"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!$('input[name="email"]').val()){
                    $('input[name="email"]').css('border', '1px solid red');
                    if (!$('input[name="email"]').next('.err').length) {
                        $('input[name="email"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Please add your email!</div>');
                        $('input[name="email"]').css('margin-bottom', '0px');                        
                    }
                }
                if (!validateEmail($('input[name="email"]').val())){
                    $('input[name="email"]').css('border', '1px solid red');
                    if (!$('input[name="email"]').next('.err').length) {
                        $('input[name="email"]').after('<div class="err" style="color: red; margin-bottom: 20px;">Email not valid!</div>');
                        $('input[name="email"]').css('margin-bottom', '0px');                        
                    }
                }
            }
        } else {
            console.log(current)
        }
    });
    $(".previous").click(function(){
    current_fs = $(this).parent();
    previous_fs = $(this).parent().prev();
    //Remove class active
    $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
    //show the previous fieldset
    previous_fs.show();
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
    step: function(now) {
    // for making fielset appear animation
    opacity = 1 - now;
    current_fs.css({
    'display': 'none',
    'position': 'relative'
    });
    previous_fs.css({'opacity': opacity});
    },
    duration: 500
    });
    setProgressBar(--current);
    });
    function setProgressBar(curStep){
    var percent = parseFloat(100 / steps) * curStep;
    percent = percent.toFixed();
    $(".progress-bar")
    .css("width",percent+"%")
    }
    $(".submit").click(function(){
        return false;
    })
});
$(document).ready(function() {
  if (window.File && window.FileList && window.FileReader) {
    $("#club_images").on("change", function(e) {
      var files = e.target.files,
        filesLength = files.length;
      for (var i = 0; i < filesLength; i++) {
        var f = files[i]
        var fileReader = new FileReader();
        fileReader.onload = (function(e) {
          var file = e.target;
          $("<span class=\"pip\">" +
            "<img class=\"imageThumb\" src=\"" + e.target.result + "\" title=\"" + file.name + "\"/>" +
            "<br/><span class=\"remove\">Remove image</span>" +
            "</span>").insertBefore("#club_images");
          $(".remove").click(function(){
            $(this).parent(".pip").remove();
          });
          // Old code here
          /*$("<img></img>", {
            class: "imageThumb",
            src: e.target.result,
            title: file.name + " | Click to remove"
          }).insertAfter("#files").click(function(){$(this).remove();});*/
        });
        fileReader.readAsDataURL(f);
      }
      console.log(files);
    });
  } else {
    alert("Your browser doesn't support to File API")
  }
});
